import styled from "styled-components";

export default styled.div `
    
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  width: 1500px;
  background-color: #00008B;
  color: #fff;
  margin: 0 15px;
  font-size: 4em;
`;